import React from "react";
import { Check, Input } from "@frui.ts/bootstrap";
import Button from "@edaz/edazkit/Button";
import LoaderOverlay from "@edaz/edazkit/LoaderOverlay";
import type { ViewComponent } from "@frui.ts/views";
import { preventDefault, registerView } from "@frui.ts/views";
import { observer } from "mobx-react-lite";
import { ButtonToolbar, Col, Form } from "react-bootstrap";
import PoliciesViewModel from "viewModels/users/accessRights/policies/policiesViewModel";
import { translateGeneral } from "utils/localizations";

const PoliciesView: ViewComponent<PoliciesViewModel> = observer(({ vm }) => {
  const disabled = !vm.isEditable;
  const trueString = translateGeneral("boolean.true");
  const falseString = translateGeneral("boolean.false");

  return (
    <LoaderOverlay loading={vm.busyWatcher.isBusy}>
      <h3 className="mb-4">{vm.name}</h3>
      <Form onSubmit={preventDefault(vm.onSavePasswordPolicy)} onReset={preventDefault(vm.onResetClick)}>
        <Form.Row>
          <Form.Group as={Col} md="6">
            <Form.Label>{vm.translateAttribute("requiredLength")}</Form.Label>
            <Input target={vm.passwordPolicy} property="requiredLength" type="number" disabled={disabled} />
          </Form.Group>
          <Form.Group as={Col} md="6">
            <Form.Label>{vm.translateAttribute("requiredUniqueChars")}</Form.Label>
            <Input target={vm.passwordPolicy} property="requiredUniqueChars" type="number" disabled={disabled} />
          </Form.Group>
        </Form.Row>
        <Form.Row>
          <Form.Group as={Col} md="6">
            <Form.Label>{vm.translateAttribute("requireLowercase")}</Form.Label>
            <div>
              <Check
                className="d-inline-block mr-4"
                custom
                type="radio"
                target={vm.passwordPolicy}
                property="requireLowercase"
                value={true}
                label={trueString}
                disabled={disabled}
              />
              <Check
                className="d-inline-block"
                custom
                type="radio"
                target={vm.passwordPolicy}
                property="requireLowercase"
                value={false}
                label={falseString}
                disabled={disabled}
              />
            </div>
          </Form.Group>
          <Form.Group as={Col} md="6">
            <Form.Label>{vm.translateAttribute("requireUppercase")}</Form.Label>
            <div>
              <Check
                className="d-inline-block mr-4"
                custom
                type="radio"
                target={vm.passwordPolicy}
                property="requireUppercase"
                value={true}
                label={trueString}
                disabled={disabled}
              />
              <Check
                className="d-inline-block"
                custom
                type="radio"
                target={vm.passwordPolicy}
                property="requireUppercase"
                value={false}
                label={falseString}
                disabled={disabled}
              />
            </div>
          </Form.Group>
        </Form.Row>
        <Form.Row>
          <Form.Group as={Col} md="6">
            <Form.Label>{vm.translateAttribute("requireNonAlphanumeric")}</Form.Label>
            <div>
              <Check
                className="d-inline-block mr-4"
                custom
                type="radio"
                target={vm.passwordPolicy}
                property="requireNonAlphanumeric"
                value={true}
                label={trueString}
                disabled={disabled}
              />
              <Check
                className="d-inline-block"
                custom
                type="radio"
                target={vm.passwordPolicy}
                property="requireNonAlphanumeric"
                value={false}
                label={falseString}
                disabled={disabled}
              />
            </div>
          </Form.Group>
          <Form.Group as={Col} md="6">
            <Form.Label>{vm.translateAttribute("requireDigit")}</Form.Label>
            <div>
              <Check
                className="d-inline-block mr-4"
                custom
                type="radio"
                target={vm.passwordPolicy}
                property="requireDigit"
                value={true}
                label={trueString}
                disabled={disabled}
              />
              <Check
                className="d-inline-block"
                custom
                type="radio"
                target={vm.passwordPolicy}
                property="requireDigit"
                value={false}
                label={falseString}
                disabled={disabled}
              />
            </div>
          </Form.Group>
        </Form.Row>
        {vm.isEditable && (
          <ButtonToolbar className="my-4 justify-content-center">
            <Button size="sm" type="reset" variant="light" disabled={!vm.isDirty}>
              {translateGeneral("reset")}
            </Button>
            <Button size="sm" type="submit" disabled={vm.busyWatcher.isBusy}>
              {translateGeneral("save")}
            </Button>
          </ButtonToolbar>
        )}
      </Form>
    </LoaderOverlay>
  );
});

registerView(PoliciesView, PoliciesViewModel);
